import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-bobbySettings",
  "use": "icon-bobbySettings-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-bobbySettings\"><path d=\"M886.4 646.4h-144L627.2 416l-89.6 326.4-60.8-656-76.8-6.4-153.6 566.4H0v80h310.4l108.8-409.6L480 969.6l76.8 6.4L646.4 640l44.8 86.4h329.6l3.2-80h-137.6z\" p-id=\"11829\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/bobbySettings.svg
// module id = edrm
// module chunks = 69